module.exports = __webpack_public_path__ + "img/convert-bomb-logo.bfc2711c.svg";